export type ThreadID = string | undefined;
export type ThreadStatus = 'READY' | 'TYPING' | 'CITING' | 'FETCHING' | 'ERROR';
export type ThreadMessageAuthor = 'USER' | 'ASSISTANT';

export interface Thread {
  id: ThreadID;
  title: string;
  items: ThreadItem[];
  filters: ThreadFilters;
}

export interface ThreadResponse {
  response: MessageChunk[];
  enabledCitation: boolean;
  sources?: ResponseSource[];
}

export interface ThreadItem extends ThreadResponse {
  id?: string;
  disliked: boolean;
  prompt: string;
  queryDate: Date;
}

export interface Citation {
  source_id: number;
  details: {
    content: string;
    relevance: string;
  }[];
}

export interface MessageChunk {
  text: string;
  citation: Citation[];
}

export interface ThreadFilters {
  countries: string[];
  sources: string[];
  earliestDate?: string;
  latestDate?: string;
}

export interface ResponseSource {
  title: string;
  url: string;
  logo: string;
}

export interface RagSource {
  source_id: number;
  file_id: string;
  file_name: string;
  related_chunks: Array<string>;
}

export const DEFAULT_FILTERS: ThreadFilters = {
  countries: [],
  sources: [],
};
